import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router'
import InterventionsSidebar from '@/components/interventions/interventions-sidebar'
import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'

export type InterventionLayoutSearch = {
  type?: string
  priority?: string
  status?: string
  trades?: string
  dispute?: string
  billing?: string
  service?: string
  siteId?: string
  equipmentId?: string
  createdBy?: string
  dateFrom?: string
  dateTo?: string
  search?: string
  sortBy?: string
  sortOrder?: string
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/interventions'
)({
  validateSearch: (
    search: Record<string, unknown>
  ): InterventionLayoutSearch => {
    const {
      type,
      priority,
      status,
      trades,
      dispute,
      billing,
      service,
      siteId,
      equipmentId,
      createdBy,
      dateFrom,
      dateTo,
      search: searchTerm,
      sortBy,
      sortOrder,
    } = search

    return {
      type: typeof type === 'string' ? type : undefined,
      priority: typeof priority === 'string' ? priority : undefined,
      status: typeof status === 'string' ? status : undefined,
      trades: typeof trades === 'string' ? trades : undefined,
      dispute: typeof dispute === 'string' ? dispute : undefined,
      billing: typeof billing === 'string' ? billing : undefined,
      service: typeof service === 'string' ? service : undefined,
      siteId: typeof siteId === 'string' ? siteId : undefined,
      equipmentId: typeof equipmentId === 'string' ? equipmentId : undefined,
      createdBy: typeof createdBy === 'string' ? createdBy : undefined,
      dateFrom: typeof dateFrom === 'string' ? dateFrom : undefined,
      dateTo: typeof dateTo === 'string' ? dateTo : undefined,
      search: typeof searchTerm === 'string' ? searchTerm : undefined,
      sortBy: typeof sortBy === 'string' ? sortBy : undefined,
      sortOrder: typeof sortOrder === 'string' ? sortOrder : undefined,
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER, UserRole.VIEWER])
  },
  component: InterventionsLayout,
})

function InterventionsLayout() {
  const isNewRoute = useMatch({
    from: '/_authenticated/org/$orgId/interventions/new',
    shouldThrow: false,
  })

  return (
    <div className='flex h-full overflow-hidden'>
      {!isNewRoute && <InterventionsSidebar />}
      <Outlet />
    </div>
  )
}
